<template>
    <div v-if="active" class="card">
        <div class="card-body">
            <PageHeader :title="screenData.text.cardTitle" variant="small" class="mb-4" />
            <div v-html="verbiage"></div>
            <ActionList :actions="screenData.actions" @accept-terms="accept" @decline-terms="decline"></ActionList>
        </div>
    </div>    
</template>

<script>
    import ActionList from '../entities/ActionList.vue';
    import PageHeader from '../entities/PageHeader.vue';

    import {PostAuthHandler} from '../mixins/PostAuthHandler.js';

    export default {
        name: "Disclaimer",

        components: {
            ActionList,
            PageHeader
        },

        mixins: [
            PostAuthHandler
        ],

        props: {
            screenData: Object
        },

        data: function() {
            return {
                active: false,
                verbiage: ""
            }
        },

        methods: {
            show: function(data) {
                this.verbiage = data.data[0];
                this.action = data.action;
                this.hasMoreWork = data.hasMoreWork;
                this.active = true;
            },

            hide: function() {
                this.active = false;
            },

            accept: function() {
                this.$emitter.emit('start-loading','accept-terms');
                this.continue();
            },

            decline: function() {
                this.$emitter.emit('start-loading','decline-terms');
                window.location.href = window.location.href;
            }
        }
    }
</script>